<template>
	<div
    v-if="videoItem.videoSrc" 
    class="video-player-container"
    :class="containerClass"
	>
    <EmbeddedVideoPlayer
      v-if="!videoItem.isVideoUnavailable"
      :videoId="`video-player-id-${videoItem.videoNum}`"
      :videoSource="videoItem.videoSrc"
      :selectedVideoId="selectedVideoId"
      @video-player-in-progress="isVideoPlayerPlayer"
    />
    <div
      v-else
      class="video-unavailability mt-4 mt-md-0 mt-lg-0 mt-xl-0"
    >
      <span>
        This video is being updated
      </span>
    </div>
	</div>
</template>

<script>
  import EmbeddedVideoPlayer from './embedded-video-player.vue';

	export default {
		components: {
			EmbeddedVideoPlayer
		},
		props: {
			videoItem: Object,
			selectedVideoId: String,
			isVideoPlayerPlayer: Function,
			containerClass: {
				type: String,
				default: ""
			}
		},
	}
</script>

<style scoped>
.video-unavailability {
    width: 100%;
    min-height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 2px solid #000;
    border-radius: 7px;
    text-align: center;
    font-family: Rajdhani;
    font-size: clamp(18px, 2vw, 22px);
    font-weight: 700;
    color: #000;
}
</style>